import React from "react";
import { ProductOrderSortTypes } from "../../../../../configs/sortTypes";
import { ProductOrderFilterType } from "../../../../../configs/filterTypes";
import ListView from "../../../../../shared/components/ListView";
import { TableColumns } from "../../../../../configs/productOrder";
import { ProductOrderRow } from "../../../../ProductOrders/Content/ProductOrderTable";

interface ProductOrdersTabProps {
    customerUUID: string
  }

const ProductOrdersTab = ({
    customerUUID
} : ProductOrdersTabProps) => {
    return (
        <ListView
            url={`/customers/${customerUUID}/sale-orders/`}
            sortTypes={ProductOrderSortTypes}
            filterTypes={ProductOrderFilterType}
            rowElement={ProductOrderRow}
            tableColumns={TableColumns}
        />
    );
};

export default ProductOrdersTab;
